/* Couchmode cart drawer: ajax add to cart from the product page + pack upgrade offer inside the drawer */
(function () {
  'use strict';
  if (window.__cmCart) return;
  window.__cmCart = true;

  var HANDLE = 'the-couchmode-blanket-hoodie';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var COLORS = [['Grey', '#A3A3A6'], ['Baby Blue', '#A9C8E8'], ['Black', '#2B2B2B'], ['Pink', '#F0B6C4'], ['Red', '#B3202A'], ['Navy', '#1F3556']];
  var productPromise = null;
  var busy = false;

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function units(v) { var m = String(v.sku || '').match(/(\d+)$/); return m ? parseInt(m[1], 10) : 1; }
  function getProduct() {
    if (!productPromise) productPromise = fetch('/products/' + HANDLE + '.js').then(function (r) { return r.json(); });
    return productPromise;
  }
  function drawerEl() { return document.querySelector('cart-drawer'); }

  var css = document.createElement('style');
  css.textContent = '.cm-up{flex-shrink:0;padding:12px 16px 14px;background:#EFE7DA;border-top:1px solid rgba(46,42,39,.1);font-family:var(--font-body-family);color:#2E2A27}' +
    '.cm-up__t{font-family:var(--font-heading-family);font-weight:900;font-size:1.7rem;margin:0 0 2px}' +
    '.cm-up__s{margin:0 0 8px;font-size:1.25rem;line-height:1.35;opacity:.85}' +
    '.cm-up__sw{display:flex;gap:8px;align-items:center;margin:0 0 8px;flex-wrap:wrap}' +
    '.cm-up__sw label{cursor:pointer;display:inline-block}' +
    '.cm-up__sw input{position:absolute;opacity:0;pointer-events:none}' +
    '.cm-up__dot{display:block;width:22px;height:22px;border-radius:50%;border:2px solid #fff;box-shadow:0 0 0 1px rgba(46,42,39,.25)}' +
    '.cm-up__sw input:checked+.cm-up__dot{box-shadow:0 0 0 2px #2E2A27}' +
    '.cm-up__sw input:focus-visible+.cm-up__dot{outline:2px solid #C8643B;outline-offset:3px}' +
    '.cm-up__row{display:flex;align-items:center;justify-content:space-between;gap:8px;background:#FBF8F3;border-radius:14px;padding:7px 10px;margin-top:6px}' +
    '.cm-up__name{font-weight:700;font-size:1.3rem;line-height:1.2}' +
    '.cm-up__tag{display:inline-block;margin-left:6px;background:#C8643B;color:#fff;border-radius:999px;padding:0 7px;font-size:1rem;font-weight:700;vertical-align:middle}' +
    '.cm-up__meta{font-size:1.1rem;opacity:.75;margin-top:1px}' +
    '.cm-up__btn{flex-shrink:0;border:0;border-radius:999px;background:#2E2A27;color:#FBF8F3;font:inherit;font-weight:700;font-size:1.2rem;padding:7px 12px;cursor:pointer}' +
    '.cm-up__btn:hover{background:#C8643B}.cm-up__btn:disabled{opacity:.6;cursor:wait}' +
    '.cm-up__err{color:#B3202A;font-size:1.2rem;margin:6px 0 0}' +
    '.cm-atc-err{color:#B3202A;font-size:1.3rem;margin:10px 0 0;text-align:center}';
  css.textContent += '.cm-timer{flex-shrink:0;margin:0 0 6px;padding:8px 12px;border-radius:12px;background:#C8643B;color:#fff;text-align:center;font-size:1.35rem;font-weight:600;line-height:1.3}.cm-timer b{font-variant-numeric:tabular-nums;font-size:1.5rem;margin-left:4px}';
  document.head.appendChild(css);

  var TKEY = 'cmCartTimerStart', TDUR = 5 * 60 * 1000;
  function tStart() {
    try {
      var v = parseInt(localStorage.getItem(TKEY), 10);
      if (v && Date.now() - v < 24 * 3600 * 1000) return v;
      v = Date.now();
      localStorage.setItem(TKEY, String(v));
      return v;
    } catch (e) { return window.__cmT || (window.__cmT = Date.now()); }
  }
  function fmt(ms) { var s = Math.max(0, Math.ceil(ms / 1000)); return ('0' + Math.floor(s / 60)).slice(-2) + ':' + ('0' + (s % 60)).slice(-2); }
  function tick() {
    var bar = document.querySelector('[data-cm-timer]');
    if (!bar) return;
    var left = tStart() + TDUR - Date.now();
    bar.innerHTML = left > 0 ? 'Your order is reserved for you <b>' + fmt(left) + '</b>' : 'Your cart is saved. Check out whenever you\'re ready.';
  }
  function timerSync() {
    var drawer = drawerEl();
    if (!drawer) return;
    var host = drawer.querySelector('cart-drawer-items');
    var has = drawer.querySelector('.cart-item');
    var bar = drawer.querySelector('[data-cm-timer]');
    if (!host || !has) {
      if (bar) bar.remove();
      try { localStorage.removeItem(TKEY); } catch (e) {}
      window.__cmT = 0;
      return;
    }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'cm-timer';
      bar.setAttribute('data-cm-timer', '');
      host.parentNode.insertBefore(bar, host);
    }
    tick();
  }
  setInterval(tick, 1000);

  async function render() {
    var drawer = drawerEl();
    if (!drawer || busy) return;
    var host = drawer.querySelector('cart-drawer-items');
    if (!host) return;
    var existing = drawer.querySelector('[data-cm-upsell]');
    var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
    var lines = cart.items.filter(function (i) { return i.handle === HANDLE; });
    var eligible = cart.items.length === 1 && lines.length === 1;
    if (!eligible) { if (existing) existing.remove(); return; }
    var line = lines[0];
    var qty = line.quantity;
    if (existing) {
      if (existing.getAttribute('data-key') === line.key && existing.getAttribute('data-qty') === String(qty)) return;
      existing.remove();
    }
    var product = await getProduct();
    var variants = product.variants.slice().sort(function (a, b) { return units(a) - units(b); });
    var current = variants.filter(function (v) { return v.id === line.variant_id; })[0];
    if (!current) return;
    var cur = units(current);
    var single = variants[0].price;
    if (qty > 1 && cur > 1) return;
    var total = cur * qty;
    var options = variants.filter(function (v) { return (qty > 1 ? units(v) >= total : units(v) > cur) && v.available; });
    if (!options.length) return;
    if (drawer.querySelector('[data-cm-upsell]')) return;
    var props = line.properties || {};
    var first = props['Hoodie 1'] || 'Red';
    var base = current.price * qty;
    var minDelta = Math.min.apply(null, options.map(function (v) { return v.price - base; }));

    var el = document.createElement('div');
    el.className = 'cm-up';
    el.setAttribute('data-cm-upsell', '');
    el.setAttribute('data-key', line.key);
    el.setAttribute('data-units', String(qty > 1 ? 1 : cur));
    el.setAttribute('data-qty', String(qty));
    el.setAttribute('data-props', encodeURIComponent(JSON.stringify(props)));
    var html = '<p class="cm-up__t">Make it a set. Save more.</p>' +
      '<p class="cm-up__s">' + (qty > 1 ? 'You have ' + qty + ' single hoodies. A pack costs less. Color for the extra ones:' : 'Add another hoodie for just <b>' + money(minDelta) + '</b>. Color for the new ones:') + '</p>' +
      '<div class="cm-up__sw" role="radiogroup" aria-label="Color for the added hoodies">';
    COLORS.forEach(function (c) {
      html += '<label><input type="radio" name="cm-up-color" value="' + c[0] + '"' + (c[0] === first ? ' checked' : '') + '><span class="cm-up__dot" style="background:' + c[1] + '"></span><span class="visually-hidden">' + c[0] + '</span></label>';
    });
    html += '</div>';
    options.forEach(function (v) {
      var u = units(v);
      var full = single * u;
      var pct = Math.round((full - v.price) * 100 / full);
      var each = Math.floor(v.price / u);
      var tag = u === 3 ? 'Most popular' : (u === 4 ? 'Best value' : '');
      html += '<div class="cm-up__row"><div><div class="cm-up__name">' + v.title + (tag ? '<span class="cm-up__tag">' + tag + '</span>' : '') + '</div>' +
        '<div class="cm-up__meta">' + money(each) + ' per hoodie' + (pct > 0 ? ' · save ' + pct + '%' : '') + '</div></div>' +
        '<button type="button" class="cm-up__btn" data-cm-upgrade data-variant="' + v.id + '" data-units="' + u + '">' + (v.price < base ? 'Switch · save ' + money(base - v.price) : 'Upgrade +' + money(v.price - base)) + '</button></div>';
    });
    html += '<p class="cm-up__err" data-cm-up-err hidden></p>';
    el.innerHTML = html;
    host.appendChild(el);
  }

  async function upgrade(btn) {
    if (busy) return;
    var box = btn.closest('[data-cm-upsell]');
    var drawer = drawerEl();
    if (!box || !drawer) return;
    var err = box.querySelector('[data-cm-up-err]');
    var color = (box.querySelector('input[name="cm-up-color"]:checked') || {}).value || 'Red';
    var newUnits = parseInt(btn.getAttribute('data-units'), 10);
    var oldUnits = parseInt(box.getAttribute('data-units'), 10);
    var props = {};
    try { props = JSON.parse(decodeURIComponent(box.getAttribute('data-props') || '%7B%7D')); } catch (e) { props = {}; }
    var np = {};
    for (var i = 1; i <= newUnits; i++) np['Hoodie ' + i] = i <= oldUnits ? (props['Hoodie ' + i] || props['Hoodie 1'] || color) : color;
    busy = true;
    var label = btn.textContent;
    box.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    btn.textContent = 'Upgrading…';
    err.hidden = true;
    var ok = false;
    try {
      var add = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant'), 10), quantity: 1, properties: np }] }) });
      if (!add.ok) throw new Error('add failed');
      var ch = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: box.getAttribute('data-key'), quantity: 0, sections: SECTIONS, sections_url: window.location.pathname }) });
      var json = await ch.json();
      if (!json.sections) throw new Error('no sections');
      busy = false;
      ok = true;
      drawer.classList.remove('is-empty');
      drawer.renderContents(json);
    } catch (e) {
      box.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
      btn.textContent = label;
      err.textContent = 'Could not update your cart. Please try again.';
      err.hidden = false;
    }
    busy = false;
    if (ok) schedule();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cm-upgrade]');
    if (b) { e.preventDefault(); upgrade(b); }
  });

  function showAtcError(f, msg) {
    var p = f.querySelector('[data-cm-atc-err]');
    if (!p) {
      p = document.createElement('p');
      p.className = 'cm-atc-err';
      p.setAttribute('data-cm-atc-err', '');
      p.setAttribute('role', 'alert');
      var btn = f.querySelector('[data-atc]');
      if (btn && btn.parentNode) btn.parentNode.insertBefore(p, btn.nextSibling); else f.appendChild(p);
    }
    p.textContent = msg;
  }
  document.addEventListener('submit', async function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (!(f.id === 'cm-form' || f.closest('[data-cm-product]'))) return;
    var sub = e.submitter;
    if (!sub || sub.name !== 'add') return;
    var drawer = drawerEl();
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    e.preventDefault();
    var buttons = Array.prototype.slice.call(document.querySelectorAll('button[name="add"]'));
    buttons.forEach(function (b) { b.disabled = true; });
    try {
      var fd = new FormData(f);
      if (!fd.get('quantity')) fd.append('quantity', '1');
      fd.append('sections', SECTIONS);
      fd.append('sections_url', window.location.pathname);
      var res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } });
      var json = await res.json();
      if (!res.ok || json.status || !json.sections) {
        showAtcError(f, json.description || json.message || 'We could not add this to your cart. Please try again.');
      } else {
        var old = f.querySelector('[data-cm-atc-err]'); if (old) old.remove();
        drawer.classList.remove('is-empty');
        drawer.renderContents(json);
      }
    } catch (err) {
      HTMLFormElement.prototype.submit.call(f);
      return;
    }
    buttons.forEach(function (b) { b.disabled = false; });
  });

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { timerSync(); render(); }, 120); }
  function isOwn(n) { return n.nodeType === 1 && n.hasAttribute && (n.hasAttribute('data-cm-upsell') || n.hasAttribute('data-cm-timer')); }
  function init() {
    var drawer = drawerEl();
    if (!drawer) return;
    new MutationObserver(function (m) {
      var own = m.every(function (x) {
        if (x.target && x.target.closest && x.target.closest('[data-cm-timer]')) return true;
        return Array.prototype.every.call(x.addedNodes, isOwn) && Array.prototype.every.call(x.removedNodes, isOwn);
      });
      if (!own) schedule();
    }).observe(drawer, { childList: true, subtree: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
